var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.33,10.41c-0.17,0.13-3.22,1.85-3.22,5.66c0,4.41,3.87,5.97,3.99,6.01c-0.02,0.1-0.62,2.14-2.04,4.22 c-1.27,1.83-2.6,3.66-4.62,3.66s-2.54-1.17-4.88-1.17c-2.27,0-3.08,1.21-4.93,1.21s-3.14-1.69-4.62-3.78 c-1.72-2.44-3.11-6.24-3.11-9.84c0-5.78,3.76-8.84,7.46-8.84c1.97,0,3.6,1.29,4.84,1.29c1.17,0,3.01-1.37,5.24-1.37 C22.28,7.46,25.32,7.54,27.33,10.41L27.33,10.41z M20.37,5.01c0.92-1.1,1.58-2.62,1.58-4.14c0-0.21-0.02-0.43-0.06-0.6 c-1.5,0.06-3.29,1-4.37,2.25c-0.85,0.96-1.64,2.49-1.64,4.03c0,0.23,0.04,0.46,0.06,0.54c0.1,0.02,0.25,0.04,0.4,0.04 C17.69,7.13,19.39,6.23,20.37,5.01L20.37,5.01z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d0233ba09e74d7984178ceec943b59d9.svg";
export { ForwardRef as ReactComponent };